import React from "react";
import { Row, Col, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faCog } from "@fortawesome/free-solid-svg-icons";

type TabType = "dashboard" | "management";

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <Row className="mb-4">
      <Col>
        <Nav className="clean-tabs justify-content-center">
          <Nav.Item>
            <Nav.Link
              eventKey="dashboard"
              active={activeTab === "dashboard"}
              onClick={() => onTabChange("dashboard")}
              className="d-flex align-items-center"
            >
              <FontAwesomeIcon
                icon={faChartBar}
                className="me-2"
                style={{ fontSize: "14px" }}
              />
              Dashboard
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="management"
              active={activeTab === "management"}
              onClick={() => onTabChange("management")}
              className="d-flex align-items-center"
            >
              <FontAwesomeIcon
                icon={faCog}
                className="me-2"
                style={{ fontSize: "14px" }}
              />
              Gerenciamento
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
    </Row>
  );
};
